import type { SVGProps } from 'react';

/**
 * The INTERIM "H" mark for The Hivez rebrand. Mirrors
 * client/src/components/icons/HivezMark.tsx and client/public/favicon.svg —
 * keep the geometry in sync with both (replace together when the designer's
 * final vector lands).
 *
 * Plain geometry: two uprights and a crossbar in a 44x44 box; the glyph
 * inherits `currentColor`.
 */
export function HivezMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <rect x="11.5" y="10" width="5.5" height="24" rx="1.25" />
      <rect x="27" y="10" width="5.5" height="24" rx="1.25" />
      <rect x="16" y="19.25" width="12" height="5" />
    </svg>
  );
}

/**
 * The H mark on its brand tile, drawn exactly like client/public/favicon.svg
 * (#F6B900 tile, #1F1A0E glyph, rx 9.68 on 44x44). Admin now has
 * `--brand-tint` / `--brand-deep` but no `--brand` fill token for the #F6B900
 * logo tile (its `--primary` is the contrast-safe accent gold, not the logo
 * yellow), so the tile carries its own colours rather than themed classes —
 * the brand yellow is the same in light and dark. Size it with `className`.
 */
export function HivezTile(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <rect width="44" height="44" rx="9.68" fill="#F6B900" />
      <g fill="#1F1A0E">
        <rect x="11.5" y="10" width="5.5" height="24" rx="1.25" />
        <rect x="27" y="10" width="5.5" height="24" rx="1.25" />
        <rect x="16" y="19.25" width="12" height="5" />
      </g>
    </svg>
  );
}
